(() => {
  if (customElements.get('eb-component-anatomy')) return;

  const prefersReduced = matchMedia('(prefers-reduced-motion: reduce)').matches;

  customElements.define('eb-component-anatomy', class extends HTMLElement {
    connectedCallback() {
      this.points = [...this.querySelectorAll('[data-anatomy-point]')];
      this.indexBtns = [...this.querySelectorAll('[data-anatomy-index-btn]')];
      this.cardSlot = this.querySelector('[data-anatomy-card-slot]');
      this.empty = this.querySelector('[data-anatomy-empty]');
      this.active = -1;

      if (!this.points.length || !this.cardSlot) return;

      this.points.forEach((point, index) => {
        point.addEventListener('click', (event) => {
          event.preventDefault();
          this.select(index);
        });
      });

      this.indexBtns.forEach((btn, index) => {
        btn.addEventListener('click', () => this.select(index, true));
      });

      this.addEventListener('keydown', (event) => {
        if (this.active < 0) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          event.preventDefault();
          this.select((this.active + 1) % this.points.length, true);
        } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          event.preventDefault();
          this.select((this.active - 1 + this.points.length) % this.points.length, true);
        }
      });

      this.select(0, false, true);
    }

    select(index, focusPoint = false, initial = false) {
      const point = this.points[index];
      if (!point) return;

      this.active = index;

      this.points.forEach((p, i) => {
        const on = i === index;
        p.classList.toggle('is-active', on);
        p.setAttribute('aria-pressed', on ? 'true' : 'false');
      });

      this.indexBtns.forEach((b, i) => {
        const on = i === index;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-current', on ? 'true' : 'false');
      });

      const template = point.querySelector('[data-anatomy-card-template]');
      if (template && 'content' in template) {
        const card = template.content.cloneNode(true);
        this.cardSlot.innerHTML = '';
        if (this.empty) this.empty.hidden = true;
        const wrap = document.createElement('div');
        wrap.className = 'eb-anatomy__card-wrap';
        wrap.appendChild(card);
        this.cardSlot.appendChild(wrap);

        if (!initial) {
          wrap.classList.add('is-entering');
          requestAnimationFrame(() => requestAnimationFrame(() => wrap.classList.remove('is-entering')));
        }

        this.countUp(wrap.querySelector('[data-anatomy-count]'), initial);
      }

      if (focusPoint) point.focus({ preventScroll: true });
    }

    // Count-up only when the hero value is a clean number (e.g. "85").
    // Mixed values like "11-50T" or "Hydraulic" render instantly.
    countUp(el, initial) {
      if (!el) return;
      const raw = el.textContent.trim();
      const target = parseFloat(raw);
      const isPlainNumber = /^\d+(\.\d+)?$/.test(raw);

      if (prefersReduced || initial || !isPlainNumber || !isFinite(target)) {
        return; // leave the value as-is
      }

      const duration = 520;
      const start = performance.now();
      const decimals = (raw.split('.')[1] || '').length;
      const ease = (t) => 1 - Math.pow(1 - t, 3);

      const tick = (now) => {
        const t = Math.min((now - start) / duration, 1);
        const v = target * ease(t);
        el.textContent = decimals ? v.toFixed(decimals) : Math.round(v).toString();
        if (t < 1) requestAnimationFrame(tick);
        else el.textContent = raw;
      };
      el.textContent = '0';
      requestAnimationFrame(tick);
    }
  });
})();

